import { Component, Input, OnInit } from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import {
	CompetencesElementaires,
	hasEmployeeSkill
} from 'src/app/shared/enums/competence.enum';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Availability } from 'src/app/shared/models/services-aide-emploi/availability';
import { Unavailability } from 'src/app/shared/models/unavailability';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-availability-employee',
	templateUrl: './availability-employee.component.html',
	styleUrls: ['./availability-employee.component.scss']
})
export class AvailabilityEmployeeComponent implements OnInit {
	@Input() employee: Employee;

	unavailabilityString = 'unavailability';
	availabilityString = 'availability';

	competences;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isSAE = false;

	unavailabilitiesMapped: {
		id: number;
		startDate: Date;
		endDate: Date;
	}[] = [];

	newUnavailability: Unavailability = new Unavailability();
	newUnavailabilityMapped: { id: number; startDate: Date; endDate: Date } = {
		id: undefined,
		startDate: undefined,
		endDate: undefined
	};

	weekDays = [
		'LUNDI',
		'MARDI',
		'MERCREDI',
		'JEUDI',
		'VENDREDI',
		'SAMEDI',
		'DIMANCHE'
	];

	//SAE
	availabilities: Availability[];
	availabilitiesMapped: {
		id: string;
		startTime: Date;
		endTime: Date;
	}[] = [];
	newAvailability: Availability = new Availability();
	newAvailabilityMapped: { id: number; startTime: Date; endTime: Date } = {
		id: undefined,
		startTime: undefined,
		endTime: undefined
	};

	availabilityCareSkills: CareSkill[] = [];

	constructor(
		private logger: LogService,
		private facade: FacadeService,
		private dateUtils: DateUtils
	) {}

	ngOnInit(): void {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.isSAE = this.facade.dataStorageService.isSAE();

		this.orderUnavailabilities();
		this.mapUnavailabilities();

		if (this.isSAE) {
			this.initAvailabilityCareSkills();
		}

		this.facade.availabilityService
			.getAllAvailabilitiesByEmployeeId(this.employee.id)
			.subscribe((availabilities: Availability[]) => {
				this.availabilities = availabilities;
				this.orderAvailabilities();
				this.mapAvailabilities();
			});
	}

	initAvailabilityCareSkills() {
		// Define a list of the competencies to check
		const competencies = [
			CompetencesElementaires.QUALIFICATION,
			CompetencesElementaires.TERRAIN,
			CompetencesElementaires.PRESCRIPTION
		];

		// Loop over each competency
		competencies.forEach((competency) => {
			if (hasEmployeeSkill(this.employee, competency)) {
				// If the employee has the competency, add it to availabilityCareSkills
				this.availabilityCareSkills.push(
					new CareSkill({
						name: competency.name,
						id: competency.id
					})
				);
			}
		});
	}

	orderUnavailabilities() {
		this.employee?.unavailabilities.sort((a, b) => {
			if (this.weekDays.indexOf(a.day) < this.weekDays.indexOf(b.day)) {
				return -1;
			}
			if (this.weekDays.indexOf(a.day) > this.weekDays.indexOf(b.day)) {
				return 1;
			}
			return 0;
		});
	}

	orderAvailabilities() {
		this.availabilities.sort((a, b) => {
			if (a.availabilityCareSkillId < b.availabilityCareSkillId) {
				return -1;
			}
			if (a.availabilityCareSkillId > b.availabilityCareSkillId) {
				return 1;
			}
			if (a.weekDay < b.weekDay) {
				return -1;
			}
			if (a.weekDay > b.weekDay) {
				return 1;
			}
			return 0;
		});
	}

	getAvailabilityDay(weekDay: number) {
		switch (weekDay) {
			case 1:
				return 'Lundi';
			case 2:
				return 'Mardi';
			case 3:
				return 'Mercredi';
			case 4:
				return 'Jeudi';
			case 5:
				return 'Vendredi';
			case 6:
				return 'Samedi';
			case 7:
				return 'Dimanche';
		}
	}

	addNewAvailability() {
		this.logger.info('' + this.newAvailability.weekDay);
		this.newAvailability.employee = this.employee;
		this.newAvailability.startTime = this.dateUtils.convertFromDateToMinutes(
			this.newAvailabilityMapped.startTime
		);
		this.newAvailability.endTime = this.dateUtils.convertFromDateToMinutes(
			this.newAvailabilityMapped.endTime
		);
		this.facade.availabilityService
			.postAvailability(this.newAvailability)
			.subscribe((availability: Availability) => {
				this.availabilities.push(availability);
				this.resetNewAvailability();
				this.mapAvailabilities();
			});
	}

	getAvailabilityCareSkill(careSkillId: number) {
		return this.availabilityCareSkills.find((a) => a.id === careSkillId).name;
	}

	mapUnavailabilities() {
		this.orderUnavailabilities();
		this.unavailabilitiesMapped = [];
		this.employee?.unavailabilities.map((unavailability: Unavailability) => {
			this.unavailabilitiesMapped.push({
				id: unavailability.id,
				startDate: new Date(
					new Date(new Date().setHours(0, 0, 0)).setMinutes(
						unavailability.start
					)
				),
				endDate: new Date(
					new Date(new Date().setHours(0, 0, 0)).setMinutes(unavailability.end)
				)
			});
		});
	}

	mapAvailabilities() {
		this.orderAvailabilities();
		this.availabilitiesMapped = [];
		this.availabilities.map((availability: Availability) => {
			this.availabilitiesMapped.push({
				id: availability.id,
				startTime: new Date(
					new Date(new Date().setHours(0, 0, 0)).setMinutes(
						availability.startTime
					)
				),
				endTime: new Date(
					new Date(new Date().setHours(0, 0, 0)).setMinutes(
						availability.endTime
					)
				)
			});
		});
	}

	deleteUnavailability(index: number) {
		this.facade.unavailabilityService
			.deleteUnavailabilityById(this.employee?.unavailabilities[index].id)
			.subscribe(() => {
				this.employee?.unavailabilities.splice(index, 1);
				this.mapUnavailabilities();
			});
	}

	deleteAvailability(availability: Availability) {
		this.facade.availabilityService
			.deleteAvailability(availability.id)
			.subscribe(() => {
				const index = this.availabilities.indexOf(availability);
				this.availabilities.splice(index, 1);
				this.mapAvailabilities();
			});
	}

	addNewUnavailability() {
		if (this.checkTime(this.unavailabilityString)) {
			this.newUnavailability.start =
				this.newUnavailabilityMapped.startDate.getHours() * 60 +
				this.newUnavailabilityMapped.startDate.getMinutes();
			this.newUnavailability.end =
				this.newUnavailabilityMapped.endDate.getHours() * 60 +
				this.newUnavailabilityMapped.endDate.getMinutes();
			this.newUnavailability.employee = this.employee;
			this.facade.unavailabilityService
				.postUnavailability(this.newUnavailability)
				.subscribe((succ: any) => {
					this.employee.unavailabilities.push(succ);
					this.resetNewUnavailability();
					this.mapUnavailabilities();
				});
		} else {
			this.facade.toastService.createWarningToast(
				"L'intervalle de temps de l'indisponibilité n'est pas valide"
			);
		}
	}

	resetNewUnavailability() {
		this.newUnavailability = new Unavailability();
		this.newUnavailabilityMapped = {
			id: undefined,
			startDate: undefined,
			endDate: undefined
		};
	}

	resetNewAvailability() {
		this.newAvailability = new Availability();
		this.newAvailabilityMapped = {
			id: undefined,
			startTime: undefined,
			endTime: undefined
		};
	}

	checkTime(type: string): boolean {
		if (type === this.unavailabilityString) {
			if (
				this.newUnavailabilityMapped.startDate &&
				this.newUnavailabilityMapped.endDate
			) {
				return (
					this.newUnavailabilityMapped.startDate?.getTime() <
					this.newUnavailabilityMapped.endDate?.getTime()
				);
			} else {
				return true;
			}
		} else if (type === this.availabilityString) {
			if (
				this.newAvailabilityMapped.startTime &&
				this.newAvailabilityMapped.endTime
			) {
				return (
					this.newAvailabilityMapped.startTime?.getTime() <
					this.newAvailabilityMapped.endTime?.getTime()
				);
			} else {
				return true;
			}
		}
	}
}
